import * as React from 'react'
import { ComparisonCardStats } from './ComparisonCardStats/ComparisonCardStats'
import { WidgetHeader } from '../WidgetHeader/WidgetHeader'
import { DateRange } from '@/hooks/useApi/types'
import ValueWithUnit from './ValueWithUnit/ValueWithUnit'

export type ComparisonCardProps = React.PropsWithChildren & {
    title: string
    currentSubtitle: string
    priorSubtitle: string
    currentValue: number
    currentValueUnit: string
    priorValue: number
    priorValueUnit: string
    currentFooterText: string
    priorFooterText: string
    currentDateRange: DateRange
    priorDateRange: DateRange
}

export const ComparisonCard: React.FC<ComparisonCardProps> = ({
    title,
    currentSubtitle,
    priorSubtitle,
    currentValue,
    currentValueUnit,
    priorValue,
    priorValueUnit,
    currentFooterText,
    priorFooterText,
    currentDateRange,
    priorDateRange,
}) => {
    return (
        <div className="box-border h-full space-y-3 rounded-xl px-4 pb-4 pt-3 shadow-inset-1 shadow-neutral-200">
            <WidgetHeader title={title} />
            <div className="flex items-stretch gap-6">
                <div className="flex-1">
                    <ComparisonCardStats
                        subtitle={currentSubtitle}
                        value={
                            <ValueWithUnit
                                value={currentValue}
                                unit={currentValueUnit}
                            />
                        }
                        current={currentValue}
                        previous={priorValue}
                        footerText={currentFooterText}
                        dateRange={currentDateRange}
                    />
                </div>
                <div className="w-px bg-neutral-200" />
                <div className="flex-1">
                    <ComparisonCardStats
                        subtitle={priorSubtitle}
                        value={
                            <ValueWithUnit
                                value={priorValue}
                                unit={priorValueUnit}
                            />
                        }
                        footerText={priorFooterText}
                        dateRange={priorDateRange}
                    />
                </div>
            </div>
        </div>
    )
}
